import { FeatureFlagDetails } from '../constants/feature-flags';

export function writeToStorage(key: string, value: any): void {
    window.localStorage.setItem(key, JSON.stringify(value));
}

export function removeFromStorage(key: string): void {
    window.localStorage.removeItem(key);
}

export function readFromStorage(key: string): any | null {
    const rawValue = window.localStorage.getItem(key);
    return rawValue ? JSON.parse(rawValue) : null;
}

export function readFromStorageWithDefault(key: string, defaultValue: any): any {
    const storageVal = readFromStorage(key);
    return storageVal === null ? defaultValue : storageVal;
}

export function checkLocalStorageFlag(key: keyof typeof FeatureFlagDetails) {
    const isFlagEnabled = readFromStorage(key) == true;
    if (isFlagEnabled) {
        const flagDetails = FeatureFlagDetails[key];
        console.log(`${flagDetails?.name || key} is enabled. To disable, remove '${key}' from local storage.`);
    }
    return isFlagEnabled;
}

export function defaultValue(key: string, value: any): any | null {
    const current = readFromStorage(key);
    if (current === null || current === undefined) {
        writeToStorage(key, value);
    }
}

export function clearLocalStorage(): void {
    window.localStorage.clear();
}
